/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StationsStationsGroupsListForStationQueryResponse, StationsStationsGroupsListForStationPathParams } from "../models/StationsStationsGroupsListForStation";

export function getStationsStationsGroupsListForStationUrl(stationId: StationsStationsGroupsListForStationPathParams["stationId"]) {
  const res = { method: 'GET', url: `/station-groups/v1/stations/${stationId}` as const }
  return res
}

/**
 * @description Returns all stations groups that include the given station.
 * @summary List stations groups for station
 * {@link /station-groups/v1/stations/:stationId}
 */
export async function stationsStationsGroupsListForStation(stationId: StationsStationsGroupsListForStationPathParams["stationId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<StationsStationsGroupsListForStationQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getStationsStationsGroupsListForStationUrl(stationId).url.toString(), ... requestConfig })
  return res.data
}